import {
  IAvisEditableListFieldArrayProps,
  IEditableListRowState,
} from "../../types";
import AvisEditableListFields from "../AvisEditableListFields";
import { AvisEditableListFooter, AvisEditableListHeader } from "./";

export function AvisEditableListTable<
  T extends object,
  P extends IEditableListRowState,
>(props: Readonly<IAvisEditableListFieldArrayProps<T, P>>): JSX.Element {
  return (
    <table className="avis-editable-list-table">
      <AvisEditableListHeader<T, P> {...props} />
      <AvisEditableListFields<T, P> {...props} />
      <AvisEditableListFooter<T, P> {...props} />
    </table>
  );
}
